import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";

import api from "../../services/api";

import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import Footer from "../../components/layout/Footer";

export default function Dashboard() {
  const [menus, setMenus] = useState([]);
  const [menuAtivo, setMenuAtivo] = useState(null);
  const location = useLocation();

  const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100vh;

  background: #f5f7f9;
`;

const BodyContainer = styled.div`
  display: flex;

  flex: 1;

  min-height: 0;
`;

const MainContent = styled.main`
  flex: 1;

  overflow: auto;

  background: #f5f7f9;
`;

  useEffect(() => {
    async function carregarMenus() {
      try {
        const response = await api.get("/api/menu");

        setMenus(response.data.menus);
      } catch (error) {
        console.error("Erro ao carregar menus:", error);
      }
    }

    carregarMenus();
  }, []);

  useEffect(() => {
    if (!menus.length) {
      return;
    }

    const menuEncontrado = menus.find((menu) =>
      menu.itens?.some((item) => item.rota === location.pathname)
    );

    if (menuEncontrado) {
      setMenuAtivo(menuEncontrado);
    }
  }, [location.pathname, menus]);

  return (
    <PageContainer>
      <Header
        menus={menus}
        menuAtivo={menuAtivo}
        setMenuAtivo={setMenuAtivo}
      />

      <BodyContainer>
        <Sidebar menuAtivo={menuAtivo} />

        <MainContent>
          <Outlet />
        </MainContent>
      </BodyContainer>

      <Footer />
    </PageContainer>
  );
}